import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollyReport from "./pages/ScrollyReport";
import FinancialReport from "./pages/FinancialReport";
import AdminUpload from "./pages/AdminUpload";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ScrollyReport />} />
          <Route path="/classic" element={<FinancialReport />} />
          <Route path="/admin/upload" element={<AdminUpload />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
